export const links = [
    {
        rel: 'dns-prefetch',
        href: 'https://fonts.googleapis.com'
    },
    {
        rel: 'icon',
        href: '../favicon.ico?v=1'
    },
    {
        rel: 'stylesheet',
        href: 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.3/css/bootstrap.min.css'
    },
    {
        rel: 'stylesheet',
        href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css'
    },
    {
        rel: 'stylesheet',
        href: 'https://unpkg.com/vue-multiselect@3.2.0/dist/vue-multiselect.min.css'
    }
];
